import { handleError, handleSuccess, triggerGet, triggerPost } from './utils';
const contactApiRequest = async (name, email, subject, message) => {
  const apiPayload = {
    contact_name: name,
    contact_email: email,
    subject: subject,
    contact_content: message
  };
  const apiResponse = await triggerPost('/public/email/contact/', apiPayload, false);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData, false, {
      email
    });
  }
  return handleError(responseData);
};
const getCustomerCoursesApiRequest = async () => {
  const apiResponse = await triggerGet('/public/products/', false);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    const {
      data
    } = handleSuccess(responseData);
    return {
      success: true,
      data
    };
  }
  return handleError(responseData);
};
const getCustomerCourseApiRequest = async id => {
  const apiResponse = await triggerGet("/public/products/".concat(id), false);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    const {
      data
    } = handleSuccess(responseData, true);
    return {
      success: true,
      data
    };
  }
  return handleError(responseData);
};
const searchCustomerProductsApiRequest = async keyword => {
  const apiResponse = await triggerGet("/public/products/search/".concat(keyword), false);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    const {
      data
    } = handleSuccess(responseData);
    return {
      success: true,
      data
    };
  }
  if (responseData.report.status === 404) {
    return {
      success: true,
      data: []
    };
  }
  return handleError(responseData);
};
const getCustomerProductApiRequest = async id => {
  const apiResponse = await triggerGet("/public/products/".concat(id), false);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    const {
      data
    } = handleSuccess(responseData, true);
    return {
      success: true,
      data
    };
  }
  return handleError(responseData);
};
const getCustomerOrderApiRequest = async orderId => {
  const apiResponse = await triggerGet("/customer/ordersb2c/".concat(orderId));
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    const {
      data
    } = handleSuccess(responseData, true);
    return {
      success: true,
      data
    };
  }
  return handleError(responseData);
};
const getCustomerOrdersApiRequest = async () => {
  const apiResponse = await triggerGet("/customer/ordersb2c/");
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};
const postCustomerOrdersApiRequest = async (userId, providerId, productId) => {
  const apiPayload = {
    ordersb2cUsersId: userId,
    ordersb2cProvidersId: providerId,
    ordersb2cProductsId: productId,
    ordersb2cReservationsId: '',
    ordersb2cSubscriptionsId: ''
  };
  const apiResponse = await triggerPost('/customer/ordersb2c/', apiPayload);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 201) {
    const {
      data,
      report
    } = handleSuccess(responseData);
    return {
      success: true,
      data,
      report
    };
  }
  return handleError(responseData);
};
const getCustomerFilesApiRequest = async id => {
  const apiResponse = await triggerGet("/public/products/".concat(id, "/files"), false);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    const {
      data
    } = handleSuccess(responseData);
    return {
      success: true,
      data
    };
  }
  return handleError(responseData);
};
const getProductFilesApiRequest = async (authHeaders, slug, id) => {
  const domain = authHeaders ? 'customer' : 'public';
  const apiResponse = await triggerGet("/".concat(domain, "/products/").concat(slug, "/files/").concat(id, "/access"), authHeaders);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    const {
      data
    } = handleSuccess(responseData);
    return {
      success: true,
      data
    };
  }
  return handleError(responseData);
};
const markFileSeenApiRequest = async (id, videoId, method) => {
  const apiResponse = await triggerGet("/customer/products/".concat(id, "/files/").concat(videoId, "/").concat(method));
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    const {
      data
    } = handleSuccess(responseData);
    return {
      success: true,
      data
    };
  }
  return handleError(responseData);
};
const getCourseSectionsDataApiRequest = async courseId => {
  const apiResponse = await triggerGet("/public/products/".concat(courseId, "/sections/"), false);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    const {
      data
    } = handleSuccess(responseData);
    return {
      success: true,
      data
    };
  }
  return handleError(responseData);
};
const getCustomerReservations = async () => {
  const apiResponse = await triggerGet('/customer/reservations');
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};
export { getCustomerReservations, contactApiRequest, getCustomerCoursesApiRequest, searchCustomerProductsApiRequest, getCustomerOrderApiRequest, getCustomerProductApiRequest, getCustomerFilesApiRequest, getCustomerOrdersApiRequest, getProductFilesApiRequest, markFileSeenApiRequest, getCourseSectionsDataApiRequest, postCustomerOrdersApiRequest, getCustomerCourseApiRequest };